import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

export class PersianDate extends Date {
  getParts = () => this.toLocaleDateString('fa-IR-u-nu-latn').split("/")
  getDay = () => super.getDay() === 6 ? 0 : super.getDay() + 1
  getDate = () => this.getParts()[2];
  getMonth = () => this.getParts()[1] - 1;
  getYear = () => this.getParts()[0];
  getMonthName = () => this.toLocaleDateString("fa-IR", { month: 'long' });
  getDayName = () => this.toLocaleDateString("fa-IR", { weekday: 'long' });
  getMonthNames = () => [
    "دی",
    "بهمن",
    "اسفند",
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
  ];
  getMonthNameByIndex = (index) => this.getMonthNames()?.[index - 1];
}

export const getMonthsAgo = (months) => {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date;
};

export const getFormattedDate = (from) => {
  return new DateObject()
    .convert(gregorian, gregorian_en)
    .toUTC()
    .format("YYYY-MM-DD")
};

export const getPersianFormattedDate = (from) => {
  return new DateObject(new Date(from))
    .convert(persian, persian_fa)
    .format()
};

